import { render } from "./AppGeneralTotalsSummary.vue?vue&type=template&id=46fedf16"
import script from "./AppGeneralTotalsSummary.vue?vue&type=script&lang=js"
export * from "./AppGeneralTotalsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__